import React from 'react';
import "../less/creditDeposit.less"
import { Preloader } from 'MWC';
import { Link } from "MWC";
import Banner from "../../../auxiliary-components/shared/Banner";
import TabsNew from "../../../auxiliary-components/shared/TabsNew";
import UsageBlock from "../../../auxiliary-components/shared/UsageBlock";
import QuestionsBlock from "../../../auxiliary-components/shared/QuestionsBlock";
import deposit_credit_ordinary from "../deposit_credit_orinary.json"
import deposit_credit_ordinary_repayment from '../deposit_credit_ordinary_repayment.json';
import deposit_credit_ordinary_conditions from '../deposit_credit_ordinary_conditions.json';
import DownloadApp from "../../Cards/views/downloadApp.c";
import ConditionsBlock from "../../../auxiliary-components/shared/ConditionsBlock";
import TextAboveFooter from "../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c";
import FilesForDownload from "../../../auxiliary-components/shared/FilesForDownload/views/file.c";

export default function template() {
    const model = this.getModel(),
        isMobile = this.isViewportMobile(),
        modes = [ {mode: 'info', title: 'CREDIT_QUICK_CASH_NAV_TITLE_1'},
            {mode: 'repayment', title: 'CREDIT_QUICK_CASH_NAV_TITLE_2'},
            {mode: 'questions', title: 'CREDIT_QUICK_CASH_NAV_TITLE_3'}],
        depositCreditFile = "https://conditions-and-rules.a-bank.com.ua/media/uploads/Kredit/KPD/Istot_KPD_ua.pdf",
        termAndConditions = "https://conditions-and-rules.a-bank.com.ua/main/view-content-524/?lang=uk",
        zajava = "https://conditions-and-rules.a-bank.com.ua/media/uploads/Kredit/KPD/Pas_KPD.pdf",
        calculator = "https://conditions-and-rules.a-bank.com.ua/media/uploads/Kredit/KPD/Kalk_KPD.xlsx",
        depositCreditTariffs = "https://conditions-and-rules.a-bank.com.ua/media/uploads/Kredit/KPD/Tarif_KPD.pdf",
        app = (
            <div className="download-app-wrapper">
                <DownloadApp {...this.props} />
            </div>
        );

    return !model.creditSum ?
        (<div className="preload-wrapper">
            <Preloader />
        </div>)
        : (
            <div className="deposit-credit-ordinary">
                <Banner
                    text={'CREDIT_DEPOSIT_CREDIT_ORDINARY_BANNER_SUBTITLE'}
                    textMob={'CREDIT_DEPOSIT_CREDIT_ORDINARY_BANNER_SUBTITLE'}
                    title={'CREDIT_DEPOSIT_CREDIT_ORDINARY_BANNER_TITLE'}
                    toggleModal={null}
                    page={'deposit-credit-ordinary'}
                    isMobile={isMobile}>
                </Banner>

                <TabsNew modes={modes} isMobile={isMobile} page={'deposit-credit-ordinary'} toggle={this.toggleMode}>
                    <div className="wrapper" type={modes[0].mode}>
                        <div className="content">
                            <ConditionsBlock isMobile={isMobile} page={'deposit-credit-ordinary'} data={deposit_credit_ordinary_conditions}></ConditionsBlock>
                            <div className="how-to-block">
                                    <div className="block-title">{this.l10n("CREDIT_DEPOSIT_CREDIT_ORDINARY_HOW_TO_TITLE")}</div>
                                    <div className="how-to-block-wrapper">
                                        <div className="block-item">
                                            <div className="block-item-step">01</div>
                                            <div className="block-item-text" dangerouslySetInnerHTML={{__html: this.l10n('CREDIT_DEPOSIT_CREDIT_ORDINARY_HOW_TO_ITEM_TEXT_1')}}></div>
                                        </div>
                                        <div className="block-item">
                                            <div className="block-item-step">02</div>
                                            <div className="block-item-text">{this.l10n("CREDIT_DEPOSIT_CREDIT_ORDINARY_HOW_TO_ITEM_TEXT_2")}</div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div className="wrapper" type={modes[1].mode}>
                        <div className="content">
                            <div className="redemption-title">{this.l10n("CREDIT_DEPOSIT_CREDIT_ORDINARY_REDEMPTION_TITLE")}</div>
                            <div className="redemption-text">{this.l10n("CREDIT_DEPOSIT_CREDIT_ORDINARY_REDEMPTION_TEXT")}</div>
                            <UsageBlock isMobile={isMobile} page={'deposit-credit-ordinary'} data={deposit_credit_ordinary_repayment} className="col-3-row-1"></UsageBlock>
                            <div className="usage-block-disclaimer">{this.l10n("CREDIT_DEPOSIT_CREDIT_ORDINARY_CREDIT_REPAYMENT_DISCLAIMER")}</div>
                            {app}
                        </div>
                    </div>
                    <div className="wrapper" type={modes[2].mode}>
                        <div className="content">
                            <QuestionsBlock isMobile={isMobile} page={'deposit-credit-ordinary'} data={deposit_credit_ordinary}></QuestionsBlock>
                            {app}
                        </div>
                    </div>
                </TabsNew>

              <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, "files_to_download")}/>
                <div className={`disclaimer-wrapper tab-${this.state.mode === 'info' ? 'active' : 'hidden'}`}>
                    <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')} />
                </div>

            </div>
        );
}
